module.exports = __webpack_public_path__ + "static/media/montserrat-light-webfont.70df5da6.ttf";